import MainLayout from '@/layouts/MainLayout.vue'; // синхронный импорт
import {app} from "@/modules/app";

app.addRoutes([
    {
        name: 'public',
        path: '/',
        component: MainLayout,
        meta: {},
    },
    {
        name: 'page',
        parent: 'public',
        path: '/page',
        component: () => import('@/layouts/PageLayout.vue'),
        meta: {
            hideOffers: true,
        },
        children: []
    },
    {
        name: 'access-denied',
        parent: 'public',
        path: '/access-denied',
        component: () => import('@/pages/access-denied.vue'),
        meta: {
            hideOffers: true,
        },
    },
    {
        name: 'catalog',
        path: '/catalog',
        component: () => import('@/layouts/CatalogLayout.vue'),
        meta: {},
        children: []
    },
    {
        name: 'clean',
        path: '/clean',
        component: () => import('@/layouts/CleanLayout.vue'),
        meta: {},
        children: []
    },
    {
        name: 'canvas',
        path: '/canvas',
        component: () => import('@/layouts/CanvasLayout.vue'),
        meta: {},
        children: []
    },
    {
        name: 'personal',
        parent: 'public',
        path: '/personal',
        component: () => import('@/layouts/PersonalLayout.vue'),
        meta: {
            auth: true,
            title: 'Личный кабинет',
            breadcrumb: {
                to: '/personal/dashboard'
            },
            hideOffers: true,
            clientOnly: false
        },
        children: []
    },
    {
        name: 'guest',
        parent: 'public',
        path: '/guest',
        component: () => import('@/layouts/GuestLayout.vue'),
        meta: {
            title: 'Кабинет',
            breadcrumb: {
                to: '/personal/guest'
            },
            hideOffers: true,
        },
        children: []
    },

    {
        name: 'not-found',
        path: '/:catchAll(.*)*',
        parent: 'clean',
        component: () => import('@/pages/error404.vue'),
        meta: {
            ssrStatus: 404,
        },
    },
])

